import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { FadeUp } from '../ui/FadeUp';
export function InsightSection() {
  return <SectionWrapper bgColor="charcoal" id="insight" className="text-center" data-id="element-122">
      <FadeUp data-id="element-123">
        <blockquote className="font-serif text-[clamp(26px,7vw,38px)] font-normal italic text-ivory leading-[1.3] mb-5 tracking-[-0.01em]" data-id="element-124">
          "Cuando no regulás tu energía, tu entorno empieza a
          <em className="text-gold-light not-italic" data-id="element-125"> decidir por vos.</em>"
        </blockquote>
      </FadeUp>

      <FadeUp delay={0.1} data-id="element-126">
        <p className="text-[13px] text-border-custom leading-[1.7]" data-id="element-127">
          Y eso tiene un costo emocional que no siempre ves.
          <br data-id="element-128" />
          <br data-id="element-129" />
          <strong className="text-ivory font-medium" data-id="element-130">
            No es falta de fortaleza. Es falta de un sistema claro que te
            devuelva el control.
          </strong>
        </p>
      </FadeUp>
    </SectionWrapper>;
}